/**
 * Utility to handle ID logic across the application.
 */

/**
 * Checks if a given ID is considered "temporary" (generated by the frontend).
 * The current convention is that temporary IDs contain a hyphen ("-").
 * 
 * @param {string|number} id - The ID to check.
 * @returns {boolean} - True if it's a temporary ID.
 */
export function isTemporaryId(id) {
    if (id === null || id === undefined) return false;
    return id.toString().indexOf("-") !== -1;
}
